import {Button, Spin} from 'antd';
import {useForm} from 'antd/es/form/Form';
import React, {FC, useState, useEffect} from 'react';

import {ModalOpenerComponent, IModalOpenerComponentProps} from 'components/modal-opener-component';
import {showMessageFromResponse} from 'shared/utils';

import {ISubmitGroupCompanyDto} from '../../../api/types';
import {SUBMIT_GROUP_COMPANY_DRAFT_NAME} from '../../../model/constants';
import {IEditSubmitCompanyCompanyForm} from '../../../model/types';
import {SubmitGroupCompanyTabService} from '../../../services';
import {SubmitGroupCompanyForm} from './submit-group-company-form';

export const EditSubmitGroupCompanyForm: FC<IEditSubmitCompanyCompanyForm> = ({
    value,
    fields,
    fetchData,
}: IEditSubmitCompanyCompanyForm) => {
    const [form] = useForm();

    const [formFieldsData, setFormFieldsData] = useState<ISubmitGroupCompanyDto>();

    const [isDataLodaing, setIsDataLodaing] = useState<boolean>(true);
    
    const [hideControlsProp, setHideControlsProp] = useState<IModalOpenerComponentProps['hideControls']>({});

    useEffect(() => {
        if (fields && fields?.status !== SUBMIT_GROUP_COMPANY_DRAFT_NAME) {
            setHideControlsProp({save: true});
        } else {
            setHideControlsProp({});
        }
    }, [fields]);

    const onFinish = async (values: ISubmitGroupCompanyDto) => {
        if (!form.isFieldsTouched()) return;
        try {
            const {response, isError} = await SubmitGroupCompanyTabService.put(values);

            if (isError) {
                showMessageFromResponse({response, isError});
            }

            await fetchData();
        } catch (e) {
            console.error(e);
        }
    };

    const onShow = async () => {
        const {data} = await SubmitGroupCompanyTabService.getById(fields.id);

        setFormFieldsData(data);

        form.setFieldsValue({
            foreignParentInfoList: data.foreignParentInfoList,
            groupCode: data.groupCode,
            groupName: data.groupName,
            hasForeignParent: data.hasForeignParent,
            headInn: data.headInn,
            headName: data.headName,
            id: data.id,
            ogrn: data.ogrn,
            reportingDate: data.reportingDate,
            requestDate: data.requestDate,
            requestId: data.requestId,
            responseDate: data.responseDate,
            responseId: data.responseId,
            result: data.result,
            resultComment: data.resultComment,
            status: data.status,
        });

        setIsDataLodaing(false);
    };

    return (
        <ModalOpenerComponent
            component={<Button type="link">{value}</Button>}
            controlsStyle={{marginTop: '20px'}}
            modalProps={{
                title: 'Запрос на изменение сведений о наименовании группы компаний и (или) головной организации группы компаний',
            }}
            hideControls={hideControlsProp}
            controlLabels={{save: 'Сохранить'}}
            handleSave={(setIsModalOpen) => {
                form.validateFields().then(() => {
                    form.submit();
                    setIsModalOpen(false);
                });
            }}
            onShow={onShow}
            shouldConfirm={() => form.isFieldsTouched()}
            handleCancel={(setIsModalOpen) => {
                form.resetFields();
                setIsModalOpen(false);
            }}
        >
            <Spin
                spinning={isDataLodaing}
                tip="Загрузка информации о записи..."
            >
                <SubmitGroupCompanyForm<ISubmitGroupCompanyDto>
                    formInstance={form}
                    onFinish={onFinish}
                    fields={formFieldsData}
                />
            </Spin>
        </ModalOpenerComponent>
    );
};
